import React, { useEffect, useState, useRef, useCallback } from 'react'

import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Toast } from 'primereact/toast'

import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'
import 'primereact/resources/primereact.css'
import 'primereact/resources/themes/lara-light-indigo/theme.css'
import { Button } from 'primereact/button'
import { Modal, notification } from 'antd'

import { api, request } from '../../../util/handlerRequestUtil'
import { getMessage } from '../../../util/IntlMessages'
import Header from './Header'
import CreateGroup from './CreateGroup'
import AddAlternativeToGroup from './Alternative/AddAlternativeToGroup'
import ListAlternatives from './Alternative/Alternatives.List'

const ListGroups = ({ customerId, groups, setGroups }) => {
  const [groupName, setGroupName] = useState('')
  const [selectedGroupId, setSelectedGroupId] = useState(null)
  const [modalDocumentVisible, setModalDocumentVisible] = useState(false)
  const [modalGroupVisible, setModalGroupVisible] = useState(false)
  const [expandedRows, setExpandedRows] = useState([])
  const toast = useRef(null)

  useEffect(() => {
    listGroupsByCustomerId(customerId)
  }, [modalGroupVisible, modalDocumentVisible, groupName])

  async function listGroupsByCustomerId(customerId) {
    setExpandedRows([])
    const groups = await request(api.listCustomerGroupByCustomerId(customerId))
    setGroups(groups)
  }

  async function removeGroup(groupId) {
    const alternativesCount = await request(api.countAlternativeDocumentsByGroupId(groupId), false, true)
    if (alternativesCount > 0) {
      notification.error({
        description: 'Antes de remover o grupo é necessário remover os alternativos',
        message: getMessage('sweetAlerts.warning')
      })
    } else {
      await request(api.removeCustomerGroup(groupId))
      notification.warning({
        description: 'Grupo removido com sucesso!',
        message: getMessage('sweetAlerts.warning')
      })
    }
    await listGroupsByCustomerId(customerId)
  }

  const actionsTemplate = ({ id, description }) => {
    return (
      <React.Fragment>
        <div style={{ display: 'flex', flexDirection: 'row', float: 'right' }}>
          <Button
            icon="pi pi-plus"
            className="btn btn-info"
            style={{ display: 'flex', justifyContent: 'center', height: 30, width: 30, lineHeight: 0.5 }}
            onClick={() => {
              setModalDocumentVisible(true)
              setSelectedGroupId(id)
            }}
          />
          <Button
            icon="pi pi-pencil"
            className="btn btn-info"
            style={{ display: 'flex', justifyContent: 'center', height: 30, width: 30, lineHeight: 0.5 }}
            onClick={() => {
              setModalGroupVisible(true)
              setSelectedGroupId(id)
              setGroupName(description)
            }}
          />
          <Button
            icon="pi pi-trash"
            className="btn btn-info"
            style={{ display: 'flex', justifyContent: 'center', height: 30, width: 30, lineHeight: 0.5 }}
            onClick={() => removeGroup(id)}
          />
        </div>
      </React.Fragment>
    )
  }

  const onRowGroupExpand = ({ data }) => {
    toast.current.show({
      severity: 'info',
      summary: 'Expandido',
      detail: 'Grupo: ' + data.description,
      life: 3000
    })
  }

  const onRowGroupCollapse = ({ data }) => {
    toast.current.show({
      severity: 'success',
      summary: 'Fechando',
      detail: 'Grupo: ' + data.description,
      life: 3000
    })
  }

  const allowExpansion = (rowData) => {
    return rowData.documents.length > 0
  }

  const rowExpansionTemplate = ({ id }) => {
    return <ListAlternatives groupId={id} />
  }

  const updateGroupsList = useCallback((newGroup) => {
    setGroups((previousList) => [...previousList, newGroup])
  }, [])

  return (
    <>
      <Header customerId={customerId} updateGroupsList={updateGroupsList} />
      <div>
        <Toast ref={toast}></Toast>
        <DataTable
          value={groups}
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          onRowExpand={onRowGroupExpand}
          onRowCollapse={onRowGroupCollapse}
          rowExpansionTemplate={rowExpansionTemplate}
          dataKey="id"
          tableStyle={{ minWidth: '100%' }}
          responsiveLayout="scroll"
        >
          <Column expander={allowExpansion} style={{ width: '5%' }} />
          <Column field="description" header="Nome do grupo" sortable style={{ width: '90%' }} />
          <Column header="Editar" body={actionsTemplate}></Column>
        </DataTable>
      </div>
      <Modal
        destroyOnClose={() => {
          setModalGroupVisible(false)
          setGroupName('')
        }}
        onCancel={() => {
          setModalGroupVisible(false)
          setGroupName('')
        }}
        title={selectedGroupId ? getMessage('updateGroup') : getMessage('createGroup')}
        footer={null}
        width="30%"
        visible={modalGroupVisible}
      >
        <CreateGroup
          groupId={selectedGroupId}
          setModalGroupVisible={setModalGroupVisible}
          customerId={customerId}
          currentGroupName={groupName}
        />
      </Modal>
      <Modal
        destroyOnClose={() => {
          setModalDocumentVisible(false)
        }}
        onCancel={() => {
          setModalDocumentVisible(false)
        }}
        title={getMessage('createAlternate')}
        footer={null}
        width="70%"
        visible={modalDocumentVisible}
      >
        <AddAlternativeToGroup groupId={selectedGroupId} setModalDocumentVisible={setModalDocumentVisible} />
      </Modal>
    </>
  )
}

export default ListGroups
